import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Bogoslivja = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Богослов'я</h1>
        <div className="text-justify hyphens-auto" id="section4">
          <div className="pt-3 pb-3">
            Після періоду практики салезіянин продовжує формацію у богословському студентаті. Цей етап триває три роки — до дияконських свячень. Після рукоположення у диякони кандидат продовжує навчання ще два роки, здобуваючи ліцензіят. У цей час він отримує священничі свячення й через лист послуху призначається до спільноти для душпастирського служіння.          </div>
          <div className="pt-3 pb-3">
            Богословська формація майбутнього священника дотримується норм Церкви та Згромадження й має на меті виховати пастиря-вихователя у салезіянському дусі (Статут 116).          </div>
          <div className="pt-3 pb-3">
            Перед дияконськими свяченнями салезіянин складає вічні обіти — зазвичай через шість років після перших (Статут 117).          </div>
          <div className="pt-3 pb-3 pt-3 pb-3 font-semibold text-[#A81414]">
            📍 Студентат: Рим


          </div>
        </div>
      </div>
    </>
  );
};

export default Bogoslivja;
